/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_TwoInputs */

const cs_enum_two = /** @type {(inputs: Enum_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2`)
};

const en_enum_two = /** @type {(inputs: Enum_TwoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2`)
};

/**
* | output |
* | --- |
* | "2" |
*
* @param {Enum_TwoInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_two = /** @type {((inputs?: Enum_TwoInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_TwoInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_two(inputs)
	return cs_enum_two(inputs)
});